import React from "react";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { ResponsiveHeroImage, ReviewRating } from "@quintype/components";
import { StoryHeaderCard } from "../story-page-components/story-header-card.js";
import { StoryTags } from "../story-page-components/story-tags.js";
import { RelatedStories } from "../story-page-components/related-stories.js";
import { StoryPageCard } from "../story-page-components/story-page-card.js";
import { DfpAd } from "../dfp-ad";
import { MetypeCommentingWidget } from "@metype/components";
import { breakpoint } from "../../../utils/breakpoint";
import { addTargetBlankToExtLinks} from "../../../utils/add-target-blank-to-extlinks";
import { altTagOfHeroImages, getSocialShareProps, getSocialShareStyle} from "../../utils";

import { SocialShare } from "@quintype/components";
import { getSocialShareTemplate } from "../story-page-components/social-share/get-social-template";

import './blank.m.css';

function renderMetype(story, metypeConfig = {}, previewStory = false) {
  if(previewStory || isEmpty(metypeConfig)) return null;

  return <div className="blank-story--metype-widget">
    <MetypeCommentingWidget
      host={metypeConfig.host}
      accountId={parseInt(metypeConfig.accountId)}
      pageURL={generateHostUrl(story)}
      primaryColor={metypeConfig.primaryColor} />
  </div>
}

function getTextStoryClass(textStory) {
  switch(textStory) {
    case 'photo-priority': return 'photo-priority-header';
    default: return '';
  }
}

function renderSocialShare(config, story, socialShareStyle, isVertical) {
  const socialShareProps = getSocialShareProps(config, story);

  return !isVertical ? null : <div className="story-byline__social-share">
    <SocialShare template={getSocialShareTemplate(socialShareStyle)} {...socialShareProps}/>
  </div>;
}

function BlankStoryTemplate(props) {
  const publisherName = get(props, ['config', 'publisher-name']);
  const metypeConfig = get(props, ['config', 'theme-attributes', 'metype-config'], {});
  const textStory = get(props, ['config', 'theme-attributes', 'text-story'], '');
  const cdnImage = get(props, ['config', 'cdn-image'], '');

  const StoryCards = props.story.cards.map((card, index) => {
    if(index === 0) {
      return <div key={card.id} className="blank-story__card--with-ad">
        <StoryPageCard key={card.id} card={card} story={props.story} cdn={cdnImage}/>
        <div className="app-ad app-ad--story-horizontal">
          <DfpAd adtype="Story-Middle-Ad"/>
        </div>
      </div>
    } else {
      return <StoryPageCard key={card.id} card={card} story={props.story} cdn={cdnImage}/>
    }
  });
  const isReviewStory = props.story["story-template"] === 'review';
  const haveFocusPoint = !!get(props, ['story', 'hero-image-metadata', 'focus-point']);
  const imageElement = breakpoint('tablet') ?
    <ResponsiveHeroImage story={props.story}
                         aspectRatio={[16,9]}
                         alt={altTagOfHeroImages(props.story)}
                         defaultWidth={480} widths={[250,480,640]} sizes="(max-width: 500px) 98%, (max-width: 768px) 48%, 98%"
                         imgParams={{auto:['format', 'compress'], fit:'max'}} /> :
    <ResponsiveHeroImage story={props.story}
                         aspectRatio={textStory === 'photo-priority' ? [16,9] : [8,3]}
                         alt={altTagOfHeroImages(props.story)}
                         defaultWidth={480} widths={[250,480,640,960,1200]} sizes="(max-width: 500px) 98%"
                         imgParams={{auto:['format', 'compress'], fit:'max'}} />;

  const socialShareStyle = getSocialShareStyle(props.config);

  const isVertical = !isReviewStory && textStory === 'photo-priority' && socialShareStyle.includes('vertical');

  return <article className="blank-story" styleName={`${isVertical ? 'vertical' : ''} ${!isReviewStory ? getTextStoryClass(textStory) : ''}`}>
    {
      props.story["hero-image-s3-key"] ?
        <figure className="blank-story-hero-image qt-responsive-image" styleName={!haveFocusPoint ? 'full-height' : ''}>
          {imageElement}
        </figure>:
        <div className="blank-story-hero-image__fallback-placeholder">
        </div>
    }
    <div className="blank-story--wrapper">
      <div styleName="blank-story-content-wrapper">
        { renderSocialShare(props.config, props.story, socialShareStyle, isVertical) }
        <div className="blank-story--content">

          <StoryHeaderCard story={props.story} config={props.config} textStory={!isReviewStory && textStory} />
          { isReviewStory && (
            <div className="rating__wrapper" data-test-id = "rating-wrapper">
              <h5 className="rating__title">{get(props.story, ['metadata','review-title'])} <span className="rating__value" data-test-id = "rating-value">({get(props.story, ['metadata','review-rating', 'value'])} / 5)</span></h5>
              <div className="rating">
                <ReviewRating value={get(props.story, ['metadata','review-rating', 'value'], '0')} />
              </div>
            </div>
          )}
          {StoryCards}
          <StoryTags tags={props.story.tags} config={props.config}/>
          <div className="blank-story__aside">
            <div className="app-ad app-ad--story-mrec">
              <DfpAd adtype="Story-Mrec"/>
            </div>
            { (isReviewStory || textStory !== 'photo-priority') && <RelatedStories story={props.story}></RelatedStories> }
          </div>
        </div>
      </div>
      { !props.preview && <div>
        <div className="app-ad app-ad--story-horizontal">
          <DfpAd adtype="Story-Bottom-Ad"/>
        </div>
        {renderMetype(props.story, metypeConfig, props.preview)}
      </div>
      }
    </div>
  </article>
}



function generateHostUrl(story = {}){
  if(global.location){
    return `${global.location.origin}/${story.slug}`;
  }
}


class BlankStory extends React.Component {
  componentDidMount() {
    addTargetBlankToExtLinks(this.storyWrapperElement);
  }
  render() {
    return <div className={`story-grid`} ref={(el) => this.storyWrapperElement = el}>
      <BlankStoryTemplate {...this.props}></BlankStoryTemplate>
    </div>
  }
}

export { BlankStory };
